// The phone FAB's geometry, shared with what must stay clear of it. Kept apart
// from PageActionsButton.tsx so a consumer does not pull in its providers.

/** The root of a PageActionsButton rendered as the phone's fixed FAB. */
export const MOBILE_FAB_ROOT_CLASS = 'Mfw-PageActionsButton-root--mobile';

/**
 * The Page that holds the phone FAB — only ITS content and footer make room
 * for the button. A modal opened over it is a Page of its own (the workout
 * editor over a client's calendar): it already covers the button, and the
 * extra room pushed its Close button off a 360px screen.
 */
export const PAGE_WITH_MOBILE_FAB = `.Mfw-Page-root:has(.${MOBILE_FAB_ROOT_CLASS})`;

/** Close to the bottom edge, above the iPhone home indicator. */
export const MOBILE_FAB_BOTTOM =
  'calc(24px + env(safe-area-inset-bottom, 0px))';

/** What a page's last control must keep clear: the offset plus the 64px box. */
export const MOBILE_FAB_CLEARANCE =
  'calc(88px + env(safe-area-inset-bottom, 0px))';

/**
 * What a control in the button's band (a page footer) must keep clear on its
 * right: the 20px inset (PageActionsButton.scss), the 54px box and 8px air.
 */
export const MOBILE_FAB_INLINE_CLEARANCE = '82px';
